import { Component, OnInit } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { AuthService } from '../../../@core/auth/services/auth.service';
import { Router } from '@angular/router';

@Component({
  selector: 'ngx-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
})
export class LoginComponent implements OnInit {
  form = {
    username: '',
    password: '',
    type: 1,
  };
  showWrongCredentialsAlert: boolean = false;
  showIndependentLoginForm: boolean = false;
  constructor(private auth: AuthService, private router: Router) {}

  ngOnInit() {}
  login() {
    if (this.form.password && this.form.password) {
      this.auth.logIn(this.form).subscribe(
        (Response) => {
          this.showWrongCredentialsAlert = false;
          this.auth.setToken(Response.token.token);
          this.auth.loadUserData();
          this.router.navigate(['/']);
        },
        (error) => {
          this.showWrongCredentialsAlert = true;
        }
      );
    }
  }
  hideAlert() {
    this.showWrongCredentialsAlert = false;
  }

  showIndependentForm() {
    this.showIndependentLoginForm = true;
  }
}
